import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import MedidasAntropometricas from '../components/MedidasAntropometricas';

export default function CreateAntropometriaPage() {
  const { idPaciente } = useParams();

  return (
    <DashboardLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <MedidasAntropometricas idPaciente={idPaciente} />
      </Container>
    </DashboardLayout>
  );
}
